
    import {createApp, computed, ComputedRef, defineComponent, reactive, onMounted, ref, nextTick, getCurrentInstance, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import pageTitle from "./_components/pageTitle.vue";
    import photoListAll from "./photoListAll.vue"
    import { Tab, Tabs } from 'scvant';
    interface Tab {
        name: string;
        num: number;
        id: string;
        photoList: Array<any>;
    }

    interface Photo {
        photoIdStr: string;
        smallPhotoUrl: string;
        photoName: string;
    }

    interface State {
        clientHeight: number; // 当前视窗高度
        modelName: string; // 车型名称
        listTab: Array<Tab>; // 照片类型分组
        actTab: string; // 当前查看照片分组id
        photoList: Array<Photo>; // 当前展示的照片列表
        isShowSwiper: boolean; // 是否展示轮播图组件
        backFun: string; // 导航返回点击方法
        swiperPhotoList: Array<Photo>; // 展示轮播图时的照片合集
        initialSlide: number; // 设定初始化时slide的索引
        isAll: boolean; // 是否显示全部黑色背景
        photoTab: number;
        imgListLen: object[]; // 图片各分组数量
        noImg: number;
    }

    export default defineComponent({
        name: "photoList",
        setup(props: any, ctx: any) {
            let state: State = reactive({
                clientHeight: 0,
                modelName: '车辆照片',
                listTab: [
                    {
                        name: '外观照片',
                        id: 'basePhoto',
                        num: 0,
                        photoList: []
                    },{
                        name: '漆面照片',
                        id: 'paintPhoto',
                        num: 0,
                        photoList: []
                    },{
                        name: '存证照片',
                        id: 'markPhoto',
                        num: 0,
                        photoList: []
                    },{
                        name: '瑕疵照片',
                        id: 'defectPhoto',
                        num: 0,
                        photoList: []
                    }

                ],
                actTab: 'basePhoto',
                photoList: [],
                isShowSwiper: false,
                backFun:'',
                swiperPhotoList: [],
                initialSlide: 0,
                isAll: false,
                photoTab: 0,
                imgListLen: [],
                noImg: 0
            })
            function urlConversion(path) {
                let reg = /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i
                path = path ? path.replace(reg, "https://$2$3$4$5$6") : path;
                return path
            }
            const {query} = useRoute();
            const store = useStore()
            const photoTabs = ref(0);
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            const {photoList, paintPhotoList, markPhotoList, modelName, defectPhotoList} = dataInfo.value as any
            // title展示文字
            if (`${query.isAll}` !== 'total') {
                state.isAll = true
                state.isShowSwiper = true
            }
            state.noImg = Number(query.noImg);
            state.swiperPhotoList = photoList && photoList.concat(paintPhotoList, markPhotoList, defectPhotoList);
            state.imgListLen = photoList && [photoList.length, paintPhotoList.length, markPhotoList.length, defectPhotoList.length];
            console.log('swiperPhotoListLen:', state.swiperPhotoList.length);
            watch((state as any).isShowSwiper, (data) => {
                if (state.isShowSwiper) {
                    state.modelName = '车辆照片';
                } else {
                    state.modelName = '全部照片';
                }
            });
            // 整理照片列表
            state.listTab.forEach((item: any) => {
                if (item.id === 'basePhoto') {
                    item.photoList = photoList;
                    item.num = photoList.length;
                    state.photoList = photoList;
                }
                if (item.id === 'paintPhoto') {
                    item.photoList = paintPhotoList && paintPhotoList !== null ? paintPhotoList : [];
                    item.num = paintPhotoList && paintPhotoList !== null ? paintPhotoList.length : 0;
                }
                if (item.id === 'markPhoto') {
                    item.photoList = markPhotoList && markPhotoList !== null ? markPhotoList : [];
                    item.num = markPhotoList && markPhotoList !== null ? markPhotoList.length : 0;
                }
                if (item.id === 'defectPhoto') {
                    item.photoList = defectPhotoList && defectPhotoList !== null ? defectPhotoList : [];
                    item.num = defectPhotoList && defectPhotoList !== null ? defectPhotoList.length : 0;
                }
            })
            // 获取当前设备高度用于设置黑色背景高度
            onMounted(() => {
                state.clientHeight = document.documentElement.clientHeight;
                // if (query.group === 'base') {
                //     state.initialSlide = Number(query.photoIndex);
                // } else {
                    // (photoTabs as any).scrollTo(state.listTab[3].id);
                    // let len0 = Number(state.imgListLen[0]);
                    // let len1 = Number(state.imgListLen[1]);
                    // let len2 = Number(state.imgListLen[2]);
                    // state.initialSlide = len0+len1+len2+Number(query.photoIndex);
                // }
                // console.log('photoList--initialSlide', state.initialSlide);
            })
            
            return {
                state,
                urlConversion,
                photoTabs
            }
        },
        mounted (){
            const {query} = useRoute();
            if (query.photoCode) {
                this.showSwiper({
                    photoIdStr: query.photoCode
                });
            }
            if (query.group === 'base') {
                this.state.initialSlide = Number(query.photoIndex);
            } else if (query.group === 'mark') {
                let data = {
                    tabIndex: 2
                }
                this.changeTab(data);
            }else{
                let data = {
                    tabIndex: 3
                }
                this.changeTab(data);
            }
            if (query.isAll === 'total') {
                this.state.isShowSwiper = false;
            }
        },
        methods: {
            changeTab(data) {
                // console.log('changeTab======:', data.tabIndex);
                (this.photoTabs as any).scrollTo(this.state.listTab[data.tabIndex].id);
                this.changePhotoType(this.state.listTab[data.tabIndex].id, 'swipe');
            },
            /**
             * 点击切换tab
             */
            changePhotoType(tabName: string, type: string ) {
                // console.log('tab:', tabName, 'type:', type);
                if (this.state.actTab === tabName) {
                    return
                }
                this.state.actTab = tabName;
                if (type==='swipe') {
                    this.state.isShowSwiper = true;
                } else {
                    this.state.isShowSwiper = false;

                }
            },
            /**
             * 点击展示当前照片轮播图组件
             * */
            showSwiper(item: any) {
                console.log('showSwipershowSwipershowSwiper');
                console.log(item);
                // this.state.isShowSwiper = false;
                let index = 0;
                for (let i = 0; i < this.state.swiperPhotoList.length; i++) {
                    let photo = this.state.swiperPhotoList[i];
                    if (photo.photoIdStr === item.photoIdStr) {
                        index = i
                        break
                    }
                }
                this.state.initialSlide = index;
                this.state.backFun = 'hiddenSwiperByTitle'
                this.state.isShowSwiper = true;
            },
            /**
             * 展示轮播图时点击左上角
             * */
            hiddenSwiperByTitle(){
                this.state.isShowSwiper = false;
                this.state.backFun = ''
            },
            /**
             * 监听全部
             */
            allPhont(data: boolean){
                this.state.isShowSwiper = false
                this.state.isAll = data
            }
        },
        components: {
            pageTitle, 
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            photoListAll
        }
    })
